module.exports = __webpack_public_path__ + "img/map-02.9854ffb5.svg";